<template>
  <div class="min-h-screen bg-white dark:bg-dark text-gray-900 dark:text-white transition-colors duration-300">
    <NavBar v-if="!isUTablePage && !isLandingPage" />
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
    <FooterSection v-if="!isUTablePage && !isLandingPage" />
  </div>
</template>

<script setup>
import { watch, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import NavBar from './components/NavBar.vue'
import FooterSection from './components/FooterSection.vue'
import { useTheme } from './composables/useTheme'

const { t, locale } = useI18n()
const route = useRoute()
const { init } = useTheme()

onMounted(() => {
  init()
})

const isUTablePage = computed(() => route.name === 'UTablePage')
const isLandingPage = computed(() => ['AiAgentInfrastructurePage', 'InfrastrutturaAiPage'].includes(route.name))

watch(
  () => ({ lang: locale.value, meta: route.meta }),
  ({ lang, meta }) => {
    document.documentElement.lang = lang
    if (meta && meta.title) {
      document.title = t(meta.title)
    }
    const metaTags = [
      { name: 'description', content: meta.description ? t(meta.description) : '' },
      { name: 'keywords', content: meta.keywords ? t(meta.keywords) : '' },
    ]
    metaTags.forEach(tagDef => {
      let tag = document.querySelector(`meta[name="${tagDef.name}"]`)
      if (!tag) {
        tag = document.createElement('meta')
        tag.setAttribute('name', tagDef.name)
        document.head.appendChild(tag)
      }
      tag.setAttribute('content', tagDef.content)
    })
  },
  { immediate: true, deep: true }
)
</script>

<style>
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s ease;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

section {
  opacity: 0;
  animation: fadeInUp 0.6s ease forwards;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Satoshi', sans-serif;
}

html {
  scroll-behavior: auto;
}
</style>
